<template>
  <footer>
    <div class="Mainfooter">
      <div class="companyAddress">
        <img src="../../assets/home/xinfen.png" />
        <div>
          <p>北京市东城区朝阳门内大街银河SOHO D座5层50531</p>
          <p>上海市黄浦区西藏南路760号安基大厦24楼</p>
          <p>深圳市南山区科园路1001号创业投资大厦37层</p>
        </div>
      </div>
      <div class="externalRelationBox">
        <div>
          <img
            src="../../assets/home/weixin.png"
            class="contentImg"
            @mouseenter="show(1)"
            @mouseleave="leave(0)"
          />
          <div class="messageWeixin" v-show="num == 1">
            <div class="triangle"></div>
            <p><img src="../../assets/home/code.png" /></p>
          </div>
          <img
            src="../../assets/home/email.png"
            class="contentImg"
            @mouseenter="show(2)"
            @mouseleave="leave(0)"
            @click="doCopy"
          />
          <div class="messageEmail" v-show="num == 2">
            <div class="triangle"></div>
            <p>ccxinss@ccxr.com.cn</p>
          </div>
          <img
            src="../../assets/home/phone.png"
            class="contentImg"
            @mouseenter="show(3)"
            @mouseleave="leave(0)"
          />
          <div class="messagePhone" v-show="num == 3">
            <div class="triangle"></div>
            <p>010-57310388</p>
          </div>
          <img
            src="../../assets/home/note.png"
            class="contentImg messageBoard"
            @mouseenter="show(4)"
            @mouseleave="leave(0)"
            @click="showDialog"
          />
          <div class="messageNote" v-show="num == 4">
            <div class="triangle"></div>
            <p>留言板</p>
          </div>
        </div>
        <p>Copyright 2019-2021 中诚信信用分析 <a href="https://beian.miit.gov.cn/" target="_blank" class="prepare">沪ICP备11030803号-4</a></p>
        <p><img src="../../assets/home/gongan.png" class="beiImg" ><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010102007062" target="_blank" class="prepare">沪公网安备 31010102007062号</a></p>
      </div>
    </div>
    <el-dialog
      title="留言板"
      :visible.sync="dialogVisible"
      custom-class="dialogClass"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :inline="true">
        <el-row>
          <el-col :xs="24" :sm="12">
            <el-form-item label="姓名" prop="userName">
              <el-input
                v-model="ruleForm.userName"
                placeholder="请输入您的姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="邮箱" prop="email">
              <el-input
                v-model="ruleForm.email"
                placeholder="请输入您的邮箱"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="12">
            <el-form-item label="手机" prop="phone">
              <el-input
                v-model="ruleForm.phone"
                placeholder="请输入您的手机号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12">
            <el-form-item label="单位" prop="organization">
              <el-input
                v-model="ruleForm.organization"
                placeholder="请输入您的工作单位"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="start">
          <el-col :xs="24" :sm="24">
            <el-form-item label="留言" prop="content" class="wt-col-24">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入您的意见或建议"
                v-model="ruleForm.content"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('ruleForm')"
          >提 交</el-button
        >
        <el-button @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
  </footer>
</template>

<script>
export default {
  name: "Mainfooter",
  data() {
    const checkSpace = (rule, value, callback) => {
      if (!value.trim()) {
        callback(new Error("不能为空"));
      } else {
        callback();
      }
    };
    return {
      num: 0,
      dialogVisible: false,
      ruleForm: {
        userName: "",
        email: "",
        phone: "",
        organization: "",
        content: "",
      },
      rules: {
        userName: [
          {
            required: true,
            message: "请输入姓名",
            validator: checkSpace,
            trigger: "blur",
          },
          {
            min: 1,
            max: 6,
            message: "长度在 1 到 6 个字符",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
            message: "请输入正确的邮箱格式",
          },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1[34578]\d{9}$/, message: "请输入正确的手机号" },
        ],
        organization: [
          {
            required: true,
            message: "请输入单位",
            validator: checkSpace,
            trigger: "blur",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "请输入留言",
            validator: checkSpace,
            trigger: "blur",
          },
          {
            min: 1,
            max: 100,
            message: "长度在 1 到 100 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {},
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http
            .post("newIndexPage/addMessageBoard", this.ruleForm)
            .then((res) => {
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.$refs["ruleForm"].resetFields();
              this.dialogVisible = false;
            });
        } else {
          return false;
        }
      });
    },
    showDialog() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.$refs["ruleForm"].resetFields();
      this.dialogVisible = false;
    },
    show(index) {
      //显示弹框信息
      this.num = index;
    },
    leave(index) {
      //隐藏弹框信息
      this.num = index;
    },
    doCopy() {
      let copytext = "ccxinss@ccxr.com.cn";
      this.$copyText(copytext).then(
        (e) => {
          this.$message({
            message: "已复制邮箱",
            type: "success",
          });
        },
        (e) => {
        }
      );
    },
  },
};
</script>

<style lang='scss' scoped>
@import './index';
</style>
